import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Event from 'types/Event';
import SourceEventType from 'sources/sourceTypes/Event';
import * as mapper from 'sources/mapper/Event';
import { PaginationParams } from 'sources/sourceTypes/Pagination';

export interface EventParams extends PaginationParams {
  ids?: number[];
}

class EventSource extends BaseSource<Event, SourceEventType, EventParams> {
  public ObjectURL = 'events' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const eventSource = new EventSource();

export default eventSource;
